import { Popconfirm } from 'antd';
import { t } from 'i18next';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { setAppLoader } from '../../../redux/common/CommonActions';
import { deleteShipmentsInProgress } from '../../../redux/shipment/ShipmentActions';
import ConfirmationModal from '../../components/Modals/ConfirmationModal';
import ScrollPagination from '../../components/Paginations/ScrollPagination';
import ContentSpinner from '../../components/Spinners/ContentSpinner';
import QuoteCard from './components/QuoteCard/QuoteCard';

const QuoteList = ({ shipmentList, onSelect, onClickStatusUpdate, selectedShipments, handleCopy, isLoading }) => {
  const [copyModalOpen, setCopyModalOpen] = useState(false);
  const dispatch = useDispatch();
  const preventBubbling =
    (callBack = () => false) =>
    (e) => {
      e.preventDefault();
      e.stopPropagation();
      callBack();
    };

  const handleDelete = (shipmentKey) => {
    dispatch(setAppLoader(true));
    dispatch(
      deleteShipmentsInProgress({
        ShipmentKeyList: shipmentKey,
      }),
    );
  };

  const getTooltipMenu = (quoteKey) => [
    {
      key: '2',
      label: (
        <Popconfirm
          placement="topRight"
          title={t('translation:default.fields.deleteConfirm.title')}
          onConfirm={preventBubbling(() => handleDelete(quoteKey))}
          okText={t('translation:default.options.yes')}
          cancelText={t('translation:default.buttons.cancel')}
          overlayClassName=""
        >
          {/* biome-ignore lint/a11y/useValidAnchor: <explanation> */}
          <a onClick={preventBubbling()} href={false}>
            {t('translation:default.buttons.delete')}
          </a>
        </Popconfirm>
      ),
    },
    {
      key: '1',
      // biome-ignore lint/a11y/useValidAnchor: <explanation>
      label: <a onClick={preventBubbling(() => setCopyModalOpen(quoteKey))}>{t('translation:default.buttons.copy')}</a>,
    },
    {
      key: '5',
      label: (
        // biome-ignore lint/a11y/useValidAnchor: <explanation>
        <a className="single-line" onClick={preventBubbling(() => onClickStatusUpdate(quoteKey))}>
          {t('translation:shipment.header.updateShipmentStatus')}
        </a>
      ),
    },
  ];

  const handleModalActions = (value) => {
    handleCopy(copyModalOpen, value);
    setCopyModalOpen(false);
  };

  if (isLoading) {
    return <ContentSpinner size="large" />;
  }
  return (
    <>
      <ScrollPagination className={`${shipmentList.length > 0 ? 'mb-15' : 'pb-15'} h-100`} isVirtualizationApproach>
        {shipmentList.map((row) => (
          <QuoteCard
            key={row.quoteKey}
            data={row}
            onSelect={onSelect}
            isSelected={selectedShipments.includes(row.quoteKey)}
            getTooltipMenu={getTooltipMenu}
          />
        ))}
      </ScrollPagination>
      <ConfirmationModal
        onOk={() => handleModalActions(1)}
        onCancel={() => handleModalActions(0)}
        onClose={() => setCopyModalOpen(false)}
        open={Boolean(copyModalOpen)}
        description={t('translation:shipment.card.description')}
        title={t('translation:shipment.card.title')}
      />
    </>
  );
};

export default QuoteList;
